/**
 * The account this browser last used (unlock-via-mac): a returning browser's usernameless sign-in
 * can then carry its unlock request in the same ceremony (faceid-signin.ts). Only an id, in IDB.
 */
import { idb } from './idb.js'

const LAST_ACCOUNT = 'viko/last-account'
let remembered: string | undefined

export async function rememberAccount(accountId: string) {
  if (remembered === accountId) return
  remembered = accountId
  await idb.set(LAST_ACCOUNT, accountId).catch(() => {})
}
export async function rememberedAccount(): Promise<string | undefined> {
  const v = await idb.get<string>(LAST_ACCOUNT).catch(() => undefined)
  return typeof v === 'string' && v ? v : undefined
}
/** Tests: a new simulated browser starts with an empty cache. */
export function _resetLastAccountCache() {
  remembered = undefined
}
